import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IReportQueryOptionsPayload } from '../types';
import {
  REPORT_REMOVE_TAB_API_URL,
  REPORT_REMOVE_TAB_MUTATION,
} from '../constants';

export default function useReportRemoveTabMutation(): IContextMutationResult<void, Error, IReportQueryOptionsPayload> {
  const { fetchDelete } = useRestClient();

  return useContextMutation<void, Error, IReportQueryOptionsPayload>({
    mutationKey: [REPORT_REMOVE_TAB_MUTATION],
    mutationFn: ({
      options: { reportType, widgetType, permission },
      tabId,
    }) => fetchDelete<void>(
      REPORT_REMOVE_TAB_API_URL,
      {
        permission,
        urlParams: {
          reportType,
          widgetType,
          tabId,
        },
      },
    ),
  });
}
